import React, { Component } from 'react';
import { message } from 'antd';
import { querySaveWorkflowTemplate } from '@api/workflow';
import BaseForm from './BaseForm';

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  handSubmit = item => {
    const context = this;
    querySaveWorkflowTemplate(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        context.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data } = this.state;
    return (
      <BaseForm
        ref={form => {
          this.form = form;
        }}
        handSubmit={this.handSubmit}
        data={data}
      />
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/PageAdd.js